import { TextField } from "@mui/material"
import { alpha } from "@mui/material"
import { TextFieldProps, Theme } from "@mui/material"
import { SxProps } from "@mui/material"
import { forwardRef } from "react"

export const TextInput = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
    return <TextField sx={styles.textField} {...props} inputRef={ref} />
})

const styles: Record<string, SxProps<Theme>> = {
    textField: {
        my: 0.5,
        "& .MuiInputLabel-root": {
            color: (theme) => theme.palette.primary.light,
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: (theme) => theme.palette.primary.light,
        },
        "& .MuiOutlinedInput-root": {
            borderRadius: 1.5,
            "& fieldset": {
                borderColor: (theme) => alpha(theme.palette.primary.light, 0.3),
            },
            "&:hover fieldset": {
                borderColor: (theme) => alpha(theme.palette.primary.light, 0.3),
            },
            "&.Mui-focused fieldset": {
                borderColor: (theme) => alpha(theme.palette.primary.light, 0.3),
            },
        },
    },
}
